import { memo } from 'react';

import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { UploadDropdownButton } from '~/components/Shared/HeaderBar/UploadDropdownButton';

export type LibraryHeaderUploadButtonProps = {
  options: DropdownMenuOption[];
};

export const LibraryHeaderUploadButton = memo(({ options }: LibraryHeaderUploadButtonProps) => (
  <UploadDropdownButton appearance="outline" iconOnly label="Upload" options={options} />
));

LibraryHeaderUploadButton.displayName = 'LibraryHeaderUploadButton';
